import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/note";


class NoteService {
    
    deleteNote(noteId:number) {
        //console.log(query)
        return axios
        .delete(API_URL + '/'+noteId)
        .then(response => {
            return response.data;
        });
    }


    editNote(data:any) {
        return axios
          .put(API_URL , data)
          .then(response => {
            return response;
          });
    }

    
   getNotes(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        console.log(response.data)
        return response.data;
      });
  }

  addNote(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }


  getNotelookups() {
    return axios
      .get(API_URL + "/lookups" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }

    
}

export default new NoteService();